var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155.8 142.1",
    style: {
      enableBackground: "new 0 0 155.8 142.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,48.4V34c-13.2,4.8-26.2,9.5-39.4,14.3V34.1c-0.4,0.1-0.6,0.1-0.7,0.2c-16.6,6-33.2,12.1-49.8,18.1 c-1,0.3-1.1,0.9-1.1,1.8c0,10.3,0,20.5,0,30.8c0,18.6,0,37.2,0,55.8v1.5h130.4V34C142.3,38.8,129.3,43.5,116,48.4z M61.4,130.6H41 V119h20.4V130.6z M41,107V95.4h20.4V107H41z M61.4,83.4H41V71.7h20.5V83.4z M82.1,95.4h20.3V107H82.1V95.4z M102.5,130.6H82.2V119 h20.3V130.6z M102.5,83.4H82.2V71.7h20.3V83.4z M123.2,95.4h20.4V107h-20.4V95.4z M143.6,130.6h-20.4V119h20.4V130.6z M143.7,83.4 h-20.5V71.7h20.5V83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,10.2c6.2,0,12.2,0,18.3,0c0,1.3,0.1,92.8,0.1,132c-6.2,0-12.2,0-18.4,0C2.3,99.5,2.3,53,2.3,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,24.8c4.6,0,9,0,13.6,0c0,0.3,0.1,0.7,0.1,1c0,5.4,0,10.7,0,16.1c0,0.4-0.3,1.1-0.6,1.2 c-4.3,1.6-8.6,3.2-13,4.8C25.1,40.1,25.1,32.5,25.1,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-0.4,6.7c0-2.2,0-4.3,0-6.5c7.8,0,15.6,0,23.4,0c0,2.1,0,4.3,0,6.5C15.3,6.7,7.5,6.7-0.4,6.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,20.8c0-2.2,0-4.3,0-6.5c7.8,0,15.6,0,23.4,0c0,2.1,0,4.3,0,6.5C35.7,20.8,27.9,20.8,20,20.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.46533a734724de3d735a0d94cb6402e3.svg";
export { ForwardRef as ReactComponent };